<template>
  <div>
    <v-card id="areas" flat class="pb-2">
      <h1 class="mb-3 primary--text">
        {{ trans('We are a cybersecurity training centre') }}
      </h1>
      <p><strong>{{ __('with a focus on 5 major areas:') }}</strong></p>
      <template

        v-for="(item, i) in programmes.items"
        >
        <v-card
          :key="i"
          light
          hover
          class="my-3"
          :href="item.link"
          :ripple="{ class: 'primary--text' }"
          >
          <v-card-text class="text-xs-center">
            <p v-html="item.title" class="mb-0"></p>
          </v-card-text>
        </v-card>
      </template>
      <v-card flat class="transparent" height="50"></v-card>
    </v-card>
  </div>
</template>

<script>
import Law from '@/modules/CDA/Home/assets/images/law.png'
import Act from '@/modules/CDA/Home/assets/images/act.png'
import Governance from '@/modules/CDA/Home/assets/images/governance.png'
import Strategic from '@/modules/CDA/Home/assets/images/strategic.png'
import Performance from '@/modules/CDA/Home/assets/images/performance.png'

export default {
  name: 'Areas',

  data () {
    return {
      programmes: {
        items: [
          {
            title: 'Cybersecurity Law & Cyber Terrorism',
            thumbnail: Law,
            link: '/programmes/cybersecurity-law-and-cyber-terrorism',
            dataDelay: 200,
          },
          {
            title: 'Cybersecurity Act 2018 Compliance',
            thumbnail: Act,
            link: '/programmes/cybersecurity-act-2018-compliance',
            dataDelay: 300,
          },
          {
            title: 'Cybersecurity Governance, Risk & Compliance',
            thumbnail: Governance,
            link: '/programmes/cybersecurity-governance-risk-and-compliance',
            dataDelay: 400,
          },
          {
            title: 'Strategic Cybersecurity Risk Management',
            thumbnail: Strategic,
            link: '/programmes/strategic-cybersecurity-risk-management',
            dataDelay: 500,
          },
          {
            title: 'Cybersecurity Performance Management',
            thumbnail: Performance,
            link: '/programmes/cybersecurity-performance-management',
            dataDelay: 600,
          }
        ]
      },
    }
  }
}
</script>
